module.exports = __webpack_public_path__ + "assets/8b0e5da82a1aa923f454ee2e6568850b.js";